// App name: AdBlue Feature Item Form
// Description:

const AdBlueFeatureItemApp = (function ($) {

  // variables
  let _container = $('.adblue-feature--container');
  let _item      = _container.find('.adblue-feature--item');

  // init
  function init() {
    initControl();
  }

  function initControl() {
    _item.on('click', function() {
      let _name = $(this).data('item-name');
      $(".form__adBlue--"+ _name).find('input').focus();
    });
  }

  return {
      init: init,
  };
})(jQuery);

jQuery('document').ready(function () {
  AdBlueFeatureItemApp.init();
});
